export const herotitle = 'Learn More About CashClever';
export const herosubtitle = `We're a team of passionate individuals dedicated to creating innovative solutions that
            empower consumers with the best financial decisions`;

export const heroImageSrc =
  'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80';
